import { render, staticRenderFns } from "./TestEmail.vue?vue&type=template&id=190066b6&"
import script from "./TestEmail.vue?vue&type=script&lang=js&"
export * from "./TestEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports